import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import api from '../../services/api_organograma';
import api_despesas from '../../services/api_despesas';
import Swal from 'sweetalert2';
import manutencaoprevisaostyles from "./manutencaoprevisao-styles.module.css";
import swalstyles from "./swal-styles.module.css";
import loadingstyles from "./loading-styles.module.css";
import previsaostyles from "./previsao-styles.module.css";
import moment from 'moment';
import { useHistory } from "react-router-dom";
import Select from 'react-select'

import { FaRedo } from 'react-icons/fa';
import { RiEdit2Fill, RiUpload2Fill } from 'react-icons/ri';
import { TiTick } from 'react-icons/ti';

function groupBy(list, key, groupKeys, singleKeys) {
    let result = {};

    list.forEach((elementList, index) => {
        if (!result.hasOwnProperty(elementList[key])) {
            result[elementList[key]] = {};
        }

        Object.keys(groupKeys).forEach((elementGroup) => {
            if (!result[elementList[key]].hasOwnProperty(elementGroup)) {
                result[elementList[key]][elementGroup] = [];
            }

            var obj = {};

            groupKeys[elementGroup].forEach((elementGroupKeys) => {
                obj[elementGroupKeys] = elementList[elementGroupKeys];
            });

            result[elementList[key]][elementGroup].push(obj);
        });

        singleKeys.forEach((elementSingle) => {
            if (!result[elementList[key]].hasOwnProperty(elementSingle)) {
                result[elementList[key]][elementSingle] = elementList[elementSingle];
            }
        });
    });

    return result;
}

export default function OrganogramaManutencaoPrevisoes() {

    let history = useHistory();

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [previsaoToEdit, setPrevisaoToEdit] = useState({});
    const [statusEdit, setStatusEdit] = useState({
        items: [
            { id: 'ab', text: "ABERTA", value: 0 },
            { id: 'ex', text: "EM EXECUÇÃO", value: 1 },
            { id: 'en', text: "ENCERRADA", value: 2 }
        ],
        selectItem: null
    });
    const [previsaoToReset, setPrevisaoToReset] = useState({});
    const [confirmDescCenario, setConfirmDescCenario] = useState('');
    const [alertDescCenario, setAlertDescCenario] = useState('');
    const [typeReset, setTypeReset] = useState({
        items: [
            { label: "QUADRO ATUAL", value: 0 }
        ],
        selectItem: 0
    });


    const [empresas, setEmpresas] = useState({
        items: [
            { value: 0, label: "TODAS AS EMPRESAS" }
        ],
        selectItem: 0
    });
    const [cenarios, setCenarios] = useState({
        items: [
            { value: 0, label: "TODOS OS CENARIOS", ids_cenario: [] }
        ],
        selectItem: 0
    });
    const [status, setStatus] = useState({
        items: [
            { value: 3, label: "TODOS OS STATUS" },
            { value: 0, label: "ABERTA" },
            { value: 1, label: "EM EXECUÇÃO" },
            { value: 2, label: "ENCERRADA" }
        ],
        selectItem: 0
    });
    const [previsoes, setPrevisoes] = useState([]);
    const [tipoDepartamento, setTipoDepartamento] = useState([
        { value: 0, label: 'AFASTADOS' },
        { value: 1, label: 'ADMINISTRAÇÃO' },
        { value: 2, label: 'MOTOR/OPER' },
        { value: 3, label: 'RURAL' },
    ]);
    const [cenariosDepartamentos, setCenariosDepartamentos] = useState([]);
    const [etapaImportacao, setEtapaImportacao] = useState({
        items: [
            { value: 0, title: 'NÃO FOI POSSÍVEL CONCLUIR O PROCESSO!', text: 'VERIFIQUE SOBRE OS ERROS INFORMADOS COM UM ADMINISTRADOR DO SISTEMA.', isEtapa: false },
            { value: 1, title: 'INICIANDO PROCESSO.', url: 'iniciaCenarioOrganograma', isEtapa: true },
            { value: 2, title: 'IMPORTANDO REGRAS DE DEPARTAMENTO.', url: 'cenariosDepartamentos', isEtapa: true },
            { value: 3, title: 'SALVANDO REGRAS DE DEPARTAMENTO.', url: 'salvarCenariosDepartamentos', isEtapa: true },
            { value: 4, title: 'IMPORTANDO ORGANOGRAMA.', url: 'importaOrganograma', isEtapa: true },
            { value: 5, title: 'IMPORTANDO ORGANOGRAMA FUNCIONÁRIO.', url: 'importaOrganogramaFuncionario', isEtapa: true },
            { value: 6, title: 'IMPORTANDO ORGANOGRAMA FUNCIONÁRIO HISTÓRICO.', url: 'importaOrganogramaFuncionarioHistorico', isEtapa: true },
            { value: 7, title: 'CONFIGURANDO PREENCHIMENTO DE VAGAS.', text: 'DESEJA QUE O SISTEMA AJUSTE AS VAGAS QUE FOREM POSSÍVEIS DE PREENCHER COM OS FUNCIONÁRIOS NÃO ESCALADOS?', isEtapa: true },
            { value: 8, title: 'PREENCHENDO VAGAS AUTOMATICAMENTE.', url: 'preencherVagas', isEtapa: true },
            { value: 9, title: 'PROCESSO FINALIZADO!', text: 'A IMPORTAÇÃO DA PREVISÃO FOI CONCLUÍDA.', isEtapa: false },
        ],
        selectItem: null,
        body: {},
    });

    useEffect(() => {
        if (empresas.items.length > 1 && cenarios.items.length > 1 && previsoes.length > 0) {
            setLoading(false);
        }
    }, [empresas, cenarios, previsoes]);

    useEffect(() => {
        api_despesas.get(`/usuario/getempresas`).then(function (response) {
            if (response.data) {
                const emps = {
                    items: [
                        { value: 0, label: "TODAS AS EMPRESAS" }
                    ],
                    selectItem: 0
                };

                response.data.empresa_usuario.forEach(emp => {
                    emps.items.push({
                        value: emp.id,
                        label: emp.descempresa
                    });
                });

                setEmpresas(emps);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });
    }, []);

    useEffect(() => {
        api.get(`/manutencaoPrevisao/getCenarios`).then(function (response) {
            if (response.data) {
                const cens = {
                    items: [
                        { value: 0, label: "TODOS OS CENARIOS", ids_cenario: [] }
                    ],
                    selectItem: 0
                };

                const agrup_cens = groupBy(response.data, 'descricao', { ids_cenario: ['id'] }, []);

                Object.keys(agrup_cens).forEach((keyCenario, index) => {
                    let ids_cenario = [];

                    agrup_cens[keyCenario].ids_cenario.forEach((element) => {
                        ids_cenario.push(element.id);
                    });

                    cens.items.push({
                        value: (index + 1),
                        label: keyCenario,
                        ids_cenario: ids_cenario,
                    });
                });

                setCenarios(cens);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });
    }, []);


    useEffect(() => {
        if (loading) {
            if(!history.location.state || (history.location.state && !history.location.state.hasAccess)) {
                history.push('/organograma');
            } else {
                api.get(`/manutencaoPrevisao/getCenariosOrganograma`).then(function (response) {
                    if (response.data) {
                        setPrevisoes(response.data);
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                });
            }
        }
    }, [loading]);

    useEffect(() => {
        if(previsaoToEdit.id || previsaoToReset.id) {
            document.body.classList.add(swalstyles.blockbody);
        }
        else {
            document.body.classList.remove(swalstyles.blockbody);
        }
    }, [previsaoToEdit, previsaoToReset]);

    useEffect(() => {
        // CONFIGURANDO PREENCHIMENTO DE VAGAS
        if(etapaImportacao.selectItem === 7) {
            setSaving(false);
        } else if(etapaImportacao.selectItem != null && etapaImportacao.items.find(({ value }) => value === etapaImportacao.selectItem).isEtapa) {
            api.post(`/manutencaoPrevisao/${etapaImportacao.items.find(({ value }) => value === etapaImportacao.selectItem).url}`, etapaImportacao.body).then(function (response) {
                if (response.data) {
                    if(response.data.error || !response.data.body) {
                        console.log(!response.data.body ? `'body' NÃO FOI RETORNADO CORRETAMENTE!` : `ERROR: ${response.data.error}`);
    
                        Swal.fire({
                            customClass: {
                                container: swalstyles.swalcontainer,
                                popup: swalstyles.swalbackground
                            },
                            title: 'UM ERRO INESPERADO ACONTECEU!',
                            text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                            icon: 'error',
                        });

                        setSaving(false);
                        setCenariosDepartamentos([]);
                        handleNextImportaPrevisao(true);
                    } else if(response.data.has_cenario_organograma) {
                        Swal.fire({
                            customClass: {
                                container: swalstyles.swalcontainer,
                                popup: swalstyles.swalbackground
                            },
                            title: 'UM ERRO INESPERADO ACONTECEU!',
                            text: 'NÃO É POSSÍVEL IMPORTAR MAIS DE UM CENÁRIO EM ABERTO NA MESMA EMPRESA',
                            icon: 'error',
                        });

                        setSaving(false);
                        handleNextImportaPrevisao(true);
                    } else if(response.data.departamentos) {
                        setSaving(false);
                        setCenariosDepartamentos(response.data.departamentos);
                    } else {
                        handleNextImportaPrevisao(false, response.data.body);
                    }
                }
            }).catch(error => {
                // handle error
                alert(error);
                console.log(error);
            });
        } else {
            setSaving(false);
            setLoading(true);
        }
    }, [etapaImportacao]);

    function handleSelectValueEtapaImportacao(value, body, obj) {
        const objselected = Object.assign([], obj);

        if(value || value === 0) {
            objselected.selectItem = parseInt(value);
        } else {
            objselected.selectItem = value;
        }
        objselected.body = body;

        return objselected;
    }

    function handleSelectValueTipo(value, index) {
        const objselected = Object.assign([], cenariosDepartamentos);
        objselected[index].cenario_departamento.afast_adm_motor_oper_rural = value;
        setCenariosDepartamentos(objselected);
    }

    function handleSelectValueQuinzena(index) {
        const objselected = Object.assign([], cenariosDepartamentos);
        objselected[index].cenario_departamento.quinzena = objselected[index].cenario_departamento.quinzena === 1 ? 0 : 1;
        setCenariosDepartamentos(objselected);
    }

    function handleSelectValueCalculo(index) {
        const objselected = Object.assign([], cenariosDepartamentos);
        objselected[index].cenario_departamento.calculo_folha = objselected[index].cenario_departamento.calculo_folha === 1 ? 0 : 1;
        setCenariosDepartamentos(objselected);
    }

    function handleSelectValue(value, obj) {
        const objselected = Object.assign([], obj);
        objselected.selectItem = parseInt(value);
        return objselected;
    }

    function handleConfirmEditPrevisao() {
        if (statusEdit.selectItem !== previsaoToEdit.status && statusEdit.selectItem === 1 && (!previsaoToEdit.data_calculo || !previsaoToEdit.primeira_importacao)) {
            handleEditPrevisao(false);

            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: [swalstyles.swalbackground, swalstyles.swalwide].join(' ')
                },
                title: 'ALTERAÇÃO DE STATUS NÃO PERMITIDA!',
                text: `A PREVISÃO SÓ PODE ENTRAR EM EXECUÇÃO APÓS O CÁLCULO SER EXECUTADO!`,
                icon: 'error',
            });
        } else if(previsaoToEdit.id === null) {
            setSaving(true);

            const body = {
                id_cenario: previsaoToEdit.bt_cenario_organograma_cenario.id,
            };

            api.post(`/manutencaoPrevisao/salvarNovoCenarioOrganograma`, body).then(function (response) {
                handleEditPrevisao(response.data.cenario_organograma);
                setSaving(false);
                setLoading(true);

                if (response.data) {
                    if (response.data.error) {
                        console.log(`ERROR: ${response.data.error}`);

                        Swal.fire({
                            customClass: {
                                container: swalstyles.swalcontainer,
                                popup: swalstyles.swalbackground
                            },
                            title: 'UM ERRO INESPERADO ACONTECEU!',
                            text: 'NÃO FOI POSSÍVEL HABILITAR A PREVISÃO',
                            icon: 'error',
                        });
                    }
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            });
        } else if (statusEdit.selectItem !== previsaoToEdit.status) {
            setSaving(true);

            const body = {
                cenario_organograma: previsaoToEdit,
                new_status: {
                    id: statusEdit.selectItem,
                    text: statusEdit.items.find(({ value }) => value === statusEdit.selectItem).text,
                },
                primeira_importacao: previsaoToEdit.primeira_importacao,
            };

            api.put(`/manutencaoPrevisao/updateStatus`, body).then(function (response) {
                handleEditPrevisao(false);
                setSaving(false);
                setLoading(true);

                if (response.data) {
                    if (response.data.error) {
                        console.log(`ERROR: ${response.data.error}`);
                    }

                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: [swalstyles.swalbackground, swalstyles.swalwide].join(' ')
                        },
                        title: response.data.title,
                        text: response.data.text,
                        icon: response.data.icon,
                    });
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            });
        } else {
            handleEditPrevisao(false);
        }
    }

    function handleEditPrevisao(previsao) {
        if(previsao) {
            setPrevisaoToEdit(previsao);
            setStatusEdit(handleSelectValue(previsao.status, statusEdit));
        }
        else {
            setPrevisaoToEdit({});
            setStatusEdit(handleSelectValue(null, statusEdit));
        }
    }

    function renderOptionsEditPrevisao() {
        return (
            statusEdit.items.map(status => {
                return (
                    <div className={swalstyles.radio} key={status.id}>
                        <input type='radio' id={status.id} name='radio_status' value={status.value}
                            checked={status.value === statusEdit.selectItem}
                            onChange={() => setStatusEdit(handleSelectValue(status.value, statusEdit))}
                            disabled={(status.value === 1 && (!previsaoToEdit.data_calculo || !previsaoToEdit.primeira_importacao)) || previsaoToEdit.id === null}
                        />
                        <label htmlFor={status.id}>{status.text}</label>
                    </div>
                )
            })
        )
    }

    function renderActionsEditPrevisao() {
        if (!saving) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                        value={previsaoToEdit.id === null ? 'HABILITAR' : 'CONFIRMAR'}
                        onClick={() => handleConfirmEditPrevisao()}
                    />
                    <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                        value='CANCELAR'
                        onClick={() => handleEditPrevisao(false)}
                    />
                </div>
            )
        }
        else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderEditPrevisao() {
        if (previsaoToEdit.id || previsaoToEdit.id === null) {
            return (
                <div className={swalstyles.conteiner}>
                    <div className={swalstyles.modal}>
                        <div className={swalstyles.conteinerbody}>
                            <div className={swalstyles.label}>EMPRESA:</div>
                            <div className={swalstyles.text}>{previsaoToEdit.bt_cenario_organograma_cenario.bt_cenario_empresa.descricao}</div>
                            <div className={swalstyles.label}>CENÁRIO:</div>
                            <div className={swalstyles.text}>{previsaoToEdit.bt_cenario_organograma_cenario.descricao}</div>
                            <div className={swalstyles.label}>SAFRA:</div>
                            <div className={swalstyles.text}>{previsaoToEdit.bt_cenario_organograma_cenario.ano_safra}</div>
                            <div className={swalstyles.label}>STATUS:</div>
                            <div className={swalstyles.conteinerradio}>
                                {renderOptionsEditPrevisao()}
                            </div>
                            <div className={swalstyles.label}>ÚLTIMO CÁLCULO DA PREVISÃO:</div>
                            <div className={swalstyles.text}>{previsaoToEdit.data_calculo ? moment(previsaoToEdit.data_calculo, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') : '(Não Calculado Ainda)'}</div>
                            {renderButtonResetPrevisao(previsaoToEdit)}
                        </div>
                        {renderActionsEditPrevisao()}
                    </div>
                </div>
            )
        }
    }

    function handleNextImportaPrevisao(error, body, jump) {
        let addEtapa = jump ? 2 : 1;

        if(error) {
            setEtapaImportacao(handleSelectValueEtapaImportacao(0, {}, etapaImportacao));
        } else if(etapaImportacao.items.length !== (etapaImportacao.selectItem + addEtapa)) {
            setEtapaImportacao(handleSelectValueEtapaImportacao(etapaImportacao.selectItem ? (etapaImportacao.selectItem + addEtapa) : addEtapa, body, etapaImportacao));
        }
    }

    function handleConfirmResetPrevisao() {
        if (!confirmDescCenario) {
            setAlertDescCenario('A DESCRIÇÃO NÃO PODE SER VAZIA!');
        } else if (previsaoToReset.bt_cenario_organograma_cenario.descricao !== confirmDescCenario) {
            setAlertDescCenario('A DESCRIÇÃO DO CENÁRIO NÃO CONFERE!');
        } else {
            setSaving(true);

            const body = {
                id_cenario_organograma: previsaoToReset.id,
                id_cenario: previsaoToReset.bt_cenario_organograma_cenario.id,
                primeira_importacao: previsaoToReset.primeira_importacao,
                id_cenario_organograma_importacao: typeReset.selectItem,
                empresa: previsaoToReset.bt_cenario_organograma_cenario.bt_cenario_empresa,
            }

            handleNextImportaPrevisao(false, body);
        }
    }

    function handleConfirmCenarioDepartamento() {
        if(cenariosDepartamentos.find(({ cenario_departamento }) => cenario_departamento.afast_adm_motor_oper_rural == null)) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swaltoastconteiner,
                    popup: swalstyles.swaltoastpopup,
                    htmlContainer: swalstyles.swaltoasttext,
                    icon: swalstyles.swaltoasticon,
                    timerProgressBar: swalstyles.swaltoastprogressbar,
                },
                position: 'top-right',
                toast: true,
                text: 'Configure Todos os Departamentos que estão Destacados!',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: false,
                icon: 'info',
            });
        } else {
            setSaving(true);

            const body = etapaImportacao.body;

            body.cenariosDepartamentos = cenariosDepartamentos.map(departamento => {
                return ({
                    id: departamento.cenario_departamento.id_cenario === body.id_cenario ? departamento.cenario_departamento.id || null : null,
                    id_cenario: body.id_cenario,
                    id_departamento: departamento.id,
                    afast_adm_motor_oper_rural: departamento.cenario_departamento.afast_adm_motor_oper_rural, 
                    quinzena: departamento.cenario_departamento.quinzena,
                    calculo_folha: departamento.cenario_departamento.calculo_folha,
                })
            });

            setCenariosDepartamentos([]);
            handleNextImportaPrevisao(false, body);
        }
    }

    function renderResetPrevisaoSelectTipo() {
        return (
            <div>
                <label htmlFor='select_tipo_importacao' className={manutencaoprevisaostyles.labelfilter}>TIPO IMPORTAÇÃO:</label>
                <Select
                    inputId='select_tipo_importacao'
                    value={typeReset.items.find(({ value }) => value === typeReset.selectItem)}
                    options={typeReset.items}
                    onChange={(e) => setTypeReset(handleSelectValue(e.value, typeReset))}
                    theme={Theme}
                />
            </div>
        )
    }

    function renderActionsResetPrevisaoConfirmCancel() {
        if(etapaImportacao.selectItem == null) {
            return (
                <>
                    <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                        value='CONFIRMAR'
                        onClick={() => handleConfirmResetPrevisao()}
                    />
                    <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                        value='CANCELAR'
                        onClick={() => handleResetPrevisao(false)}
                    />
                </>
            )
        }
    }

    function renderActionsResetPrevisaoConfirmCloseDepartamentos() {
        if(cenariosDepartamentos.length) {
            return (
                <>
                    <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                        value='CONFIRMAR'
                        onClick={() => handleConfirmCenarioDepartamento()}
                    />
                    <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                        value='FECHAR'
                        onClick={() => handleResetPrevisao(false)}
                    />
                </>
            )
        }
    }

    function renderActionsResetPrevisaoFechar() {
        if(etapaImportacao.selectItem != null && ((etapaImportacao.selectItem + 1) === etapaImportacao.items.length || etapaImportacao.selectItem === 0)) {
            return (
                <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                    value='FECHAR'
                    onClick={() => handleResetPrevisao(false)}
                />
            )
        }
    }

    function renderActionsResetPrevisao() {
        if (!saving) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    {renderActionsResetPrevisaoConfirmCancel()}
                    {renderActionsResetPrevisaoConfirmCloseDepartamentos()}
                    {renderActionsResetPrevisaoFechar()}
                </div>
            )
        }
        else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderResetPrevisaoTitle() {
        if(previsaoToReset.primeira_importacao) {
            return (
                <div>CONFIRME A REDEFINIÇÃO DOS DADOS.</div>
            )
        } else {
            return (
                <div>CONFIRME A INSERÇÃO DOS DADOS.</div>
            )
        }
    }

    function renderBodyCenariosDepartamentos() {
        return (
            cenariosDepartamentos.map((departamento, index) => {
                return (
                    <div className={departamento.cenario_departamento.id ? swalstyles.cenariosdepartamentogrid : [swalstyles.cenariosdepartamentogrid, swalstyles.cenariosdepartamentogriderro].join(' ')} key={index}>
                        <div className={swalstyles.cenariosdepartamentogriddpto}>{departamento.codigo} - {departamento.descricao}</div>
                        <Select
                            value={tipoDepartamento.find(({ value }) => value === departamento.cenario_departamento.afast_adm_motor_oper_rural)}
                            options={tipoDepartamento}
                            onChange={(e) => handleSelectValueTipo(e.value, index)}
                            theme={Theme}
                            className={previsaostyles.filterselect}
                            placeholder='Selecione um Tipo'
                        />
                        <div className={[swalstyles.checkconteiner, swalstyles.conteinercheckcenariodepartamento].join(' ')} onClick={() => {handleSelectValueQuinzena(index)}}>
                            <TiTick className={departamento.cenario_departamento.quinzena ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                        </div>
                        <div className={[swalstyles.checkconteiner, swalstyles.conteinercheckcenariodepartamento].join(' ')} onClick={() => {handleSelectValueCalculo(index)}}>
                            <TiTick className={departamento.cenario_departamento.calculo_folha ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                        </div>
                    </div>
                )
            })
        )
    }

    function renderChoosePreencheVagas() {
        if(etapaImportacao.selectItem === 7) {
            return(
                <div>
                    <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                        value='PREENCHER AS VAGAS'
                        onClick={() => {
                            handleNextImportaPrevisao(false, etapaImportacao.body);
                            setSaving(true);
                        }}
                    />
                    <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                        value='PULAR ESSA ETAPA'
                        onClick={() => {
                            handleNextImportaPrevisao(false, etapaImportacao.body, true);
                            setSaving(true);
                        }}
                    />
                </div>
            )
        }
    }

    function renderCenariosDepartamentos() {
        if(cenariosDepartamentos.length) {
            return (
                <>
                    <div className={[swalstyles.cenariosdepartamentogrid, swalstyles.cenariosdepartamentogridhead].join(' ')}>
                        <div>DEPARTAMENTO</div>
                        <div>TIPO</div>
                        <div>QUINZENA</div>
                        <div>CALC. FOLHA</div>
                    </div>
                    {renderBodyCenariosDepartamentos()}
                </>
            )
        }
    }

    function renderStatusImportacao() {
        if(etapaImportacao.selectItem != null && !cenariosDepartamentos.length) {
            return (
                <div>
                    <div>
                        {etapaImportacao.items.find(({ value }) => value === etapaImportacao.selectItem).title}
                    </div>
                    <div>
                        {etapaImportacao.items.find(({ value }) => value === etapaImportacao.selectItem).text}
                    </div>
                </div>
            )
        } else if(!cenariosDepartamentos.length) {
            return (
                <div>UM ERRO INESPERADO ACONTECEU!</div>
            )
        }
    }

    function renderEtapaImportacao() {
        if(etapaImportacao.selectItem != null && etapaImportacao.items.find(({ value }) => value === etapaImportacao.selectItem).isEtapa) {
            return (
                <>
                    Etapa: {etapaImportacao.selectItem} de {etapaImportacao.items.filter(({ isEtapa }) => isEtapa).length}
                    <div className={loadingstyles.ldsellipsis}><div></div><div></div><div></div><div></div></div>
                </>
            )
        }
    }

    function renderResetPrevisaoBody() {
        if(etapaImportacao.selectItem != null) {
            return (
                <>
                    <div className={swalstyles.titlemodalcalculo}>
                        IMPORTANDO ESCALA
                    </div>
                    <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight, swalstyles.conteinerbodyenableoverflowx].join(' ')}>
                        {renderCenariosDepartamentos()}
                        <div className={swalstyles.conteinerstatuscalculo}>
                            {renderStatusImportacao()}
                            {renderChoosePreencheVagas()}
                            <div className={swalstyles.conteineretapacalculo}>
                                {renderEtapaImportacao()}
                            </div>
                        </div>
                    </div>
                </>
            )
        } else {
            return (
                <div className={swalstyles.conteinerbody}>
                    <div className={swalstyles.conteineralert}>
                        <div className={[swalstyles.textalert, swalstyles.titlealert].join(' ')}>
                            {renderResetPrevisaoTitle()}
                            <div>A NOVA ESCALA SERÁ GERADA DE ACORDO COM O TIPO SELECIONADO.</div>
                        </div>
                        <div className={swalstyles.textalert}>
                            <div>INSIRA A DESCRIÇÃO DO CENÁRIO PARA CONFIRMAR A OPERAÇÃO.</div>
                            <div className={swalstyles.boldalert}>{previsaoToReset.bt_cenario_organograma_cenario.descricao}</div>
                        </div>
                    </div>
                    <div className={swalstyles.conteinerinputconfirmdesc}>
                        <input type='text' className={swalstyles.inputconfirmdesc} value={confirmDescCenario}
                            onChange={(e) => setConfirmDescCenario(e.target.value)} onClick={() => setAlertDescCenario('')} />
                        <div className={swalstyles.textalerterro}>
                            {alertDescCenario}
                        </div>
                    </div>
                    {renderResetPrevisaoSelectTipo()}
                </div>
            )
        }
    }

    function renderResetPrevisao() {
        if (previsaoToReset.id) {
            return (
                <div className={swalstyles.conteiner}>
                    <div className={cenariosDepartamentos.length ? [swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight3rows].join(' ') : swalstyles.modal}>
                        {renderResetPrevisaoBody()}
                        {renderActionsResetPrevisao()}
                    </div>
                </div>
            )
        }
    }

    function insertOptionReset(previsao) {
        const obj = Object.assign([], typeReset);

        previsoes.filter(
            (prev) => prev.status !== 0 && prev.bt_cenario_organograma_cenario.bt_cenario_empresa.id === previsao.bt_cenario_organograma_cenario.bt_cenario_empresa.id
        ).forEach((prev, index) => {
            if(index <= 1) {
                obj.items.push({
                    label: prev.bt_cenario_organograma_cenario.descricao,
                    value: prev.id,
                });
            }
        });

        return obj;
    }

    function handleResetPrevisao(previsao) {
        if (previsao) {
            handleEditPrevisao(false)
            setPrevisaoToReset(previsao);
            setTypeReset(insertOptionReset(previsao));
        } else {
            setConfirmDescCenario('');
            setAlertDescCenario('')
            setPrevisaoToReset({});
            setTypeReset({
                items: [
                    { label: "QUADRO ATUAL", value: 0 },
                ],
                selectItem: 0
            });
            setCenariosDepartamentos([]);
            setEtapaImportacao(handleSelectValueEtapaImportacao(null, {}, etapaImportacao));
        }
    }

    function handlePopupShow(e) {
        if(e.type === 'mouseenter') {
            e.currentTarget.parentElement.children[0].classList.add(swalstyles.popupshow);
        } else {
            e.currentTarget.parentElement.children[0].classList.remove(swalstyles.popupshow);
        }
    }

    function Theme(theme) {
        return ({
            ...theme,
            colors: {
                ...theme.colors,
                primary: '#d4d4d4', // CHOOSED
                primary50: '#e7e7e7', // CLICK
                primary25: '#f3f3f3', // HOVER
            }
        })
    }

    function renderFilter() {
        return (
            <div className={manutencaoprevisaostyles.gridfilter}>
                <div className={[manutencaoprevisaostyles.conteinerfilter, manutencaoprevisaostyles.filtergridareacenario].join(' ')}>
                    <label htmlFor='select_cenario' className={manutencaoprevisaostyles.labelfilter}>CENÁRIO:</label>
                    <Select
                        inputId='select_cenario'
                        value={cenarios.items.find(({ value }) => value === cenarios.selectItem)}
                        options={cenarios.items}
                        onChange={(e) => setCenarios(handleSelectValue(e.value, cenarios))}
                        theme={Theme}
                    />
                </div>
                <div className={[manutencaoprevisaostyles.conteinerfilter, manutencaoprevisaostyles.filtergridareaempresa].join(' ')}>
                    <label htmlFor='select_empresa' className={manutencaoprevisaostyles.labelfilter}>EMPRESA:</label>
                    <Select
                        inputId='select_empresa'
                        value={empresas.items.find(({ value }) => value === empresas.selectItem)}
                        options={empresas.items}
                        onChange={(e) => setEmpresas(handleSelectValue(e.value, empresas))}
                        theme={Theme}
                    />
                </div>
                <div className={[manutencaoprevisaostyles.conteinerfilter, manutencaoprevisaostyles.filtergridareastatus].join(' ')}>
                    <label htmlFor='select_status' className={manutencaoprevisaostyles.labelfilter}>STATUS:</label>
                    <Select
                        inputId='select_status'
                        value={status.items.find(({ value }) => value === status.selectItem)}
                        options={status.items}
                        onChange={(e) => setStatus(handleSelectValue(e.value, status))}
                        theme={Theme}
                    />
                </div>
            </div>
        )
    }

    function renderStatusPrevisao(status) {
        let descricao_status;

        if (status === 0) {
            descricao_status = 'ABERTA';
        } else if (status === 1) {
            descricao_status = 'EM EXECUÇÃO';
        } else {
            descricao_status = 'ENCERRADA';
        }

        return (
            <div>{descricao_status}</div>
        )
    }

    function renderButtonResetPrevisao(previsao) {
        if (previsao.id && previsao.status === 0 && previsao.primeira_importacao) {
            return (
                <div className={manutencaoprevisaostyles.conteinerbuttonresetprevisao}>
                    <div className={swalstyles.conteinerpopup}>
                        <span className={swalstyles.popup}>Reiniciar Previsão</span>
                        <FaRedo className={[manutencaoprevisaostyles.buttoneditresetprevisao, manutencaoprevisaostyles.buttonresetprevisao].join(' ')}
                            onClick={() => { handleResetPrevisao(previsao) }} onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                        />
                    </div>
                </div>
            )
        } else if (previsao.id && previsao.status === 0) {
            return (
                <div className={manutencaoprevisaostyles.conteinerbuttonresetprevisao}>
                    <div className={swalstyles.conteinerpopup}>
                        <span className={swalstyles.popup}>Primeira Importação</span>
                        <div className={manutencaoprevisaostyles.conteinerbuttonprimeiroloadprevisao}
                            onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)} onClick={() => { handleResetPrevisao(previsao) }}
                        >
                            <FaRedo className={manutencaoprevisaostyles.buttonresetprevisao}/>
                            <span className={manutencaoprevisaostyles.primeiroloadprevisao}></span>
                        </div>
                    </div>
                </div>
            )
        } else if(previsao.id === null) {
            return (
                <div className={[swalstyles.boldalert, swalstyles.redalert].join(' ')}>
                    Habilite a Nova Previsão para Importar o Organograma
                </div>
            )
        }
    }

    function renderBodyPrevisao() {
        if (!loading) {
            return (
                previsoes.map((previsao, index) => {
                    if (
                        (
                            empresas.items.find(({ value }) => value === empresas.selectItem).value === previsao.bt_cenario_organograma_cenario.bt_cenario_empresa.id ||
                            empresas.selectItem === 0
                        ) &&
                        (
                            cenarios.items.find(({ value }) => value === cenarios.selectItem).ids_cenario.includes(previsao.bt_cenario_organograma_cenario.id) ||
                            cenarios.selectItem === 0
                        ) &&
                        (
                            status.selectItem === previsao.status || status.selectItem === 3
                        )
                    ) {
                        if(previsao.status === 2) {
                            return (
                                <div className={[manutencaoprevisaostyles.gridprevisoes, manutencaoprevisaostyles.bodyprevisoes].join(' ')} key={index}>
                                    <div className={[manutencaoprevisaostyles.gridprevisoestable, manutencaoprevisaostyles.gridprevisoestablebody].join(' ')}
                                        onClick={() => { history.push('/previsao', { id_cenario_organograma: previsao.id, hasAccess: true }) }}
                                    >
                                        <div>{previsao.bt_cenario_organograma_cenario.bt_cenario_empresa.descricao}</div>
                                        <div>{previsao.bt_cenario_organograma_cenario.descricao}</div>
                                        {renderStatusPrevisao(previsao.status)}
                                        <div className={manutencaoprevisaostyles.calculado}>{previsao.data_calculo ? 'CALCULADO' : null}</div>
                                    </div>
                                    <div className={swalstyles.conteinerpopup}>
                                        <span className={swalstyles.popup}>Editar</span>
                                        <RiEdit2Fill className={manutencaoprevisaostyles.buttoneditresetprevisao} onClick={() => { handleEditPrevisao(previsao) }}
                                            onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                                        />
                                    </div>
                                </div>
                            )
                        } else if(previsao.id) {
                            return (
                                <div className={[manutencaoprevisaostyles.gridprevisoes, manutencaoprevisaostyles.bodyprevisoes].join(' ')} key={index}>
                                    <div className={[manutencaoprevisaostyles.gridprevisoestable, manutencaoprevisaostyles.gridprevisoestablebody].join(' ')}
                                        onClick={() => { history.push('/previsao', { id_cenario_organograma: previsao.id, hasAccess: true }) }}
                                    >
                                        <div>{previsao.bt_cenario_organograma_cenario.bt_cenario_empresa.descricao}</div>
                                        <div>{previsao.bt_cenario_organograma_cenario.descricao}</div>
                                        {renderStatusPrevisao(previsao.status)}
                                        <div className={manutencaoprevisaostyles.calculado}>{previsao.data_calculo ? 'CALCULADO' : null}</div>
                                    </div>
                                    <div className={swalstyles.conteinerpopup}>
                                        <span className={swalstyles.popup}>Editar</span>
                                        <RiEdit2Fill className={manutencaoprevisaostyles.buttoneditresetprevisao} onClick={() => { handleEditPrevisao(previsao) }}
                                            onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                                        />
                                    </div>
                                </div>
                            )
                        } else {
                            return (
                                <div className={[manutencaoprevisaostyles.gridprevisoes, manutencaoprevisaostyles.bodyprevisoes].join(' ')} key={index}>
                                    <div className={[manutencaoprevisaostyles.gridprevisoestable, manutencaoprevisaostyles.gridprevisoestablebodyhabilitar].join(' ')}>
                                        <div>{previsao.bt_cenario_organograma_cenario.bt_cenario_empresa.descricao}</div>
                                        <div>{previsao.bt_cenario_organograma_cenario.descricao}</div>
                                        {renderStatusPrevisao(previsao.status)}
                                        <div className={manutencaoprevisaostyles.calculado}>{previsao.data_calculo ? 'CALCULADO' : null}</div>
                                    </div>
                                    <div className={swalstyles.conteinerpopup}>
                                        <span className={swalstyles.popup}>Habilitar<br />Nova Previsão</span>
                                        <RiUpload2Fill className={manutencaoprevisaostyles.buttoneditresetprevisao} onClick={() => { handleEditPrevisao(previsao) }}
                                            onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                                        />
                                    </div>
                                </div>
                            )
                        }
                    }
                })
            )
        }
    }

    function renderLoadingEscala() {
        if(loading) {
            return (
                <div className={[swalstyles.conteiner, swalstyles.conteinerloading].join(' ')}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderPrevisoes() {
        return (
            <div className={manutencaoprevisaostyles.conteinerprevisoes}>
                {renderLoadingEscala()}
                <div className={[manutencaoprevisaostyles.gridprevisoes, manutencaoprevisaostyles.headerprevisoes].join(' ')}>
                    <div className={manutencaoprevisaostyles.gridprevisoestable}>
                        <div>EMPRESA</div>
                        <div>CENÁRIO</div>
                        <div>STATUS</div>
                        <div className={manutencaoprevisaostyles.calculado}></div>
                    </div>
                </div>
                {renderBodyPrevisao()}
            </div>
        )

    }

    function renderManutencao() {
        return (
            <>
                {renderFilter()}
                {renderPrevisoes()}
            </>
        )
    }

    return (
        <>
            {renderResetPrevisao()}
            {renderEditPrevisao()}
            <div className="container-lg">
                <Header title="MANUTENÇÃO DE PREVISÃO DE ESCALA" />
                {renderManutencao()}
            </div>
        </>
    )
}